function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import "broadcastchannel-polyfill";
import { useEffect, useState } from "react";
import { usePersistFn } from "./usePersistFn";
var useLocalStorage = function useLocalStorage(key, initialValue, raw) {
  var _useState = useState(function () {
      try {
        var localStorageValue = localStorage.getItem(key);
        if (typeof localStorageValue !== "string") {
          localStorage.setItem(key, raw ? String(initialValue) : JSON.stringify(initialValue));
          return initialValue;
        } else {
          return raw ? localStorageValue : JSON.parse(localStorageValue || "null");
        }
      } catch (_unused) {
        // If user is in private mode or has storage restriction
        // localStorage can throw. JSON.parse and JSON.stringify
        // can throw, too.
        return initialValue;
      }
    }),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var handleStorage = usePersistFn(function (event) {
    if (event.key === key) {
      try {
        var localStorageValue = event.newValue;
        if (typeof localStorageValue !== "string") {
          setState(initialValue);
        } else {
          setState(raw ? localStorageValue : JSON.parse(localStorageValue));
        }
      } catch (_unused2) {
        setState(initialValue);
      }
    }
  });
  useEffect(function () {
    // 添加本地的 storage 事件监听器
    window.addEventListener("storage", handleStorage);

    // 添加广播通道的消息监听器
    var broadcastChannel = new BroadcastChannel(key);
    broadcastChannel.onmessage = function (event) {
      setState(event.data);
    };
    return function () {
      // 移除本地的 storage 事件监听器
      window.removeEventListener("storage", handleStorage);

      // 关闭广播通道
      broadcastChannel.close();
    };
  }, [handleStorage, key]);
  var setValue = usePersistFn(function (value) {
    if (typeof value === "function") {
      setState(function (prevState) {
        var newValue = value(prevState);
        try {
          var serializedState = raw ? String(newValue) : JSON.stringify(newValue);
          localStorage.setItem(key, serializedState);

          // 广播通道中的消息
          var broadcastChannel = new BroadcastChannel(key);
          broadcastChannel.postMessage(newValue);
        } catch (_unused3) {
          // If user is in private mode or has storage restriction
          // localStorage can throw. Also JSON.stringify can throw.
        }
        return newValue;
      });
    } else {
      try {
        var serializedState = raw ? String(value) : JSON.stringify(value);
        localStorage.setItem(key, serializedState);

        // 广播通道中的消息
        var broadcastChannel = new BroadcastChannel(key);
        broadcastChannel.postMessage(value);
      } catch (_unused4) {
        // If user is in private mode or has storage restriction
        // localStorage can throw. Also JSON.stringify can throw.
      }
      setState(value);
    }
  });
  return [state, setValue];
};
export default useLocalStorage;